import { useState } from 'react';

export default function usePost(url, urlIdentifier = null) {
    console.log(`${process.env.REACT_APP_API_URL}/${url}`)
    const [error, setError] = useState();
    const [data, setData] = useState();
    const [loading, setLoading] = useState(false);
    const call = async(data) => {
        setLoading(true);
        try {
            const response = await fetch(`${urlIdentifier === 'loan' ? process.env.REACT_APP_LOAN_API_URL : process.env.REACT_APP_API_URL}/${url}`, {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            const result = await response.json();
            if (response.ok) {
                setData(result);
            } else {
                setError(result);
            }
        } catch (err) {
            console.log({errorPost: err})
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return [call, data, error, loading];
}